const STORAGE_KEY = "nm_home_content";

/* eslint-disable global-require */
const DEFAULT_HERO_IMAGES = [
  require("../hero-section/img/hero-img-01.jpg"),
  require("../hero-section/img/hero-img-03.jpg"),
  require("../hero-section/img/hero-img-02.jpg"),
];

const DEFAULT_CLIENT_IMAGES = [
  require("../clients-section/img/client-1.png"),
  require("../clients-section/img/client-2.png"),
  require("../clients-section/img/client-3.png"),
  require("../clients-section/img/client-4.png"),
  require("../clients-section/img/client-5.png"),
  require("../clients-section/img/client-6.png"),
  require("../clients-section/img/client-7.png"),
];

const DEFAULT_APPROACH_ICONS = [
  require("../advantage-preview/img/advantage-icon-01.svg"),
  require("../advantage-preview/img/advantage-icon-02.svg"),
  require("../advantage-preview/img/advantage-icon-03.svg"),
  require("../advantage-preview/img/advantage-icon-04.svg"),
  require("../advantage-preview/img/advantage-icon-05.svg"),
  require("../advantage-preview/img/advantage-icon-06.svg"),
];
/* eslint-enable global-require */

const DEFAULT_CLIENTS_TITLE = "*Клиенты* нам доверяют";
const DEFAULT_APPROACH_TITLE = "*Наш подход* к работе";
const DEFAULT_SERVICES_SECTION_TITLE = "*Услуги* компании";

const DEFAULT_APPROACH_ITEMS = [
  {
    id: "approach-1",
    title: "Гарантия",
    text: "Компания предоставляет гарантию на всю продукцию производства. Срок нарантии — один год. Цена не будет меняться на всех этапах ведения проекта.",
    icon: "",
    iconIndex: 0,
  },
  {
    id: "approach-2",
    title: "Стабильность цены",
    text: "Специалисты компании произведут детальный расчёт стоимости, с учётом всех особенностей и пожеланий клиента, предложат комфортную цену.",
    icon: "",
    iconIndex: 1,
  },
  {
    id: "approach-3",
    title: "Соблюдение сроков",
    text: "Соблюдение чётких сроков заказа рекламы. Компания обговаривает все сроки с заказчиком на начальном этапе и подкрепляем это документацией.",
    icon: "",
    iconIndex: 2,
  },
  {
    id: "approach-4",
    title: "Решения для бизнеса",
    text: "В компании над каждым заказом работают маркетологи, которые обладают большой компетенцией в сфере рекламы. Специалисты окажут индивидуальную помощь.",
    icon: "",
    iconIndex: 3,
  },
  {
    id: "approach-5",
    title: "Материалы и печать",
    text: "Все материалы и комплектующие закупаются только у проверенных рынком поставщиков. Материалы с сомнительным качеством не используется в производстве.",
    icon: "",
    iconIndex: 4,
  },
  {
    id: "approach-6",
    title: "Доставка по РФ",
    text: "Все материалы и комплектующие закупаются только у проверенных рынком поставщиков. Материалы с сомнительным качеством не используется в производстве.",
    icon: "",
    iconIndex: 5,
  },
];

const DEFAULT_DESCRIPTION = {
  title: "Компания НОВАЯ МАРКА предоставляет широкий спектр услуг по изготовлению рекламы в Пензе и в регионах России",
  paragraph1:
    "Рекламно-производственная компания «Новая Марка». Мы делаем вывески, полиграфию и сувенирную продукцию. На рынке более 15 лет. Имеем выполненные проекты в 30 регионах России и портфолио успешной работы с 17 компаниями из ТОП 100 в списке Forbes.",
  paragraph2:
    "Компания «Новая Марка» с 2003 года предоставляет широкий спектр услуг в сфере производства рекламы. Каждый год мы решаем сложные задачи. Развиваемся вместе с нашими клиентами.",
};

const DEFAULT_ACHIEVEMENTS = [
  { value: "20", label: "лет безупречного опыта" },
  { value: ">10 800", label: "выполненных рекламных проектов" },
  { value: "17", label: "компаний из ТОП-Forbes нам доверяют" },
];

const DEFAULT_SLIDES = [
  {
    id: "hero-1",
    title: "*Производство и установка* входных групп, *инсталляций*, стел и арт-объектов",
    buttonText: "Заказать рекламу",
    image: "",
    imageIndex: 0,
  },
  {
    id: "hero-2",
    title: "*Брендирование* транспорта",
    buttonText: "Заказать рекламу",
    image: "",
    imageIndex: 1,
  },
  {
    id: "hero-3",
    title: "Доски почета —проектирование и установка",
    buttonText: "Заказать рекламу",
    image: "",
    imageIndex: 2,
  },
];

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function createId() {
  return `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
}

function getDefaultClients() {
  return {
    title: DEFAULT_CLIENTS_TITLE,
    items: DEFAULT_CLIENT_IMAGES.map((image, index) => ({
      id: `client-${index + 1}`,
      image: "",
      imageIndex: index,
      alt: "Логотип",
    })),
  };
}

function getDefaultApproach() {
  return {
    title: DEFAULT_APPROACH_TITLE,
    items: DEFAULT_APPROACH_ITEMS.map((item) => ({ ...item })),
  };
}

function getDefaultServicesSection() {
  return {
    title: DEFAULT_SERVICES_SECTION_TITLE,
  };
}

function getDefaultData() {
  return {
    slides: DEFAULT_SLIDES.map((item) => ({ ...item })),
    description: { ...DEFAULT_DESCRIPTION },
    achievements: DEFAULT_ACHIEVEMENTS.map((item) => ({ ...item })),
    clients: getDefaultClients(),
    approach: getDefaultApproach(),
    servicesSection: getDefaultServicesSection(),
  };
}

function normalizeAchievement(item = {}, fallback = {}) {
  return {
    value: String(item.value || fallback.value || "").trim(),
    label: String(item.label || fallback.label || "").trim(),
  };
}

function normalizeSlide(item = {}, index = 0) {
  const imageIndex = Number.isFinite(Number(item.imageIndex))
    ? Math.max(0, Math.min(DEFAULT_HERO_IMAGES.length - 1, Number(item.imageIndex)))
    : Math.min(index, DEFAULT_HERO_IMAGES.length - 1);

  return {
    id: String(item.id || createId()),
    title: String(item.title || "").trim(),
    buttonText: String(item.buttonText || "Заказать рекламу").trim() || "Заказать рекламу",
    image: String(item.image || "").trim(),
    imageIndex,
  };
}

function normalizeClientItem(item = {}, index = 0) {
  const imageIndex = Number.isFinite(Number(item.imageIndex))
    ? Math.max(0, Math.min(DEFAULT_CLIENT_IMAGES.length - 1, Number(item.imageIndex)))
    : Math.min(index, DEFAULT_CLIENT_IMAGES.length - 1);

  return {
    id: String(item.id || createId()),
    image: String(item.image || "").trim(),
    imageIndex,
    alt: String(item.alt || "Логотип").trim() || "Логотип",
  };
}

function normalizeClients(raw) {
  const fallback = getDefaultClients();
  // Missing key (old saved home docs) → keep current site defaults, do not invent empty list.
  if (!raw || typeof raw !== "object") return fallback;

  const title = String(raw.title || fallback.title).trim() || fallback.title;
  if (!Array.isArray(raw.items)) {
    return { title, items: fallback.items.map((item) => ({ ...item })) };
  }

  const items = raw.items
    .map((item, index) => normalizeClientItem(item, index))
    .filter((item) => item.image || item.imageIndex >= 0);

  return { title, items };
}

function normalizeApproachItem(item = {}, index = 0) {
  const iconIndex = Number.isFinite(Number(item.iconIndex))
    ? Math.max(0, Math.min(DEFAULT_APPROACH_ICONS.length - 1, Number(item.iconIndex)))
    : Math.min(index, DEFAULT_APPROACH_ICONS.length - 1);

  return {
    id: String(item.id || createId()),
    title: String(item.title || "").trim(),
    text: String(item.text || "").trim(),
    icon: String(item.icon || "").trim(),
    iconIndex,
  };
}

function normalizeApproach(raw) {
  const fallback = getDefaultApproach();
  if (!raw || typeof raw !== "object") return fallback;

  const title = String(raw.title || fallback.title).trim() || fallback.title;
  if (!Array.isArray(raw.items)) {
    return { title, items: fallback.items.map((item) => ({ ...item })) };
  }

  const items = raw.items
    .map((item, index) => normalizeApproachItem(item, index))
    .filter((item) => item.title && item.text);

  return {
    title,
    items: items.length ? items : fallback.items.map((item) => ({ ...item })),
  };
}

function normalizeServicesSection(raw) {
  const fallback = getDefaultServicesSection();
  if (!raw || typeof raw !== "object") return fallback;
  const title = String(raw.title || fallback.title).trim() || fallback.title;
  return { title };
}

function normalizeData(raw) {
  const fallback = getDefaultData();
  if (!raw || typeof raw !== "object") return fallback;

  const description = raw.description && typeof raw.description === "object"
    ? {
      title: String(raw.description.title || fallback.description.title),
      paragraph1: String(raw.description.paragraph1 || fallback.description.paragraph1),
      paragraph2: String(raw.description.paragraph2 || fallback.description.paragraph2),
    }
    : { ...fallback.description };

  const achievementsSource = Array.isArray(raw.achievements) ? raw.achievements : fallback.achievements;
  const achievements = fallback.achievements.map((item, index) => (
    normalizeAchievement(achievementsSource[index], item)
  ));

  const slides = Array.isArray(raw.slides) && raw.slides.length
    ? raw.slides.map(normalizeSlide).filter((item) => item.title)
    : fallback.slides.map((item) => ({ ...item }));

  return {
    slides,
    description,
    achievements,
    clients: normalizeClients(raw.clients),
    approach: normalizeApproach(raw.approach),
    servicesSection: normalizeServicesSection(raw.servicesSection),
  };
}

function getHomeData() {
  const cached = window.NMApi?.cache?.home;
  if (cached) return normalizeData(cached);
  return getDefaultData();
}

function saveHomeData(data) {
  const normalized = normalizeData(data);
  if (window.NMApi) {
    window.NMApi.cache.home = normalized;
    window.NMApi.save("home", normalized).catch((error) => {
      window.alert(error.message || "Не удалось сохранить главную"); // eslint-disable-line no-alert
    });
  }
  return normalized;
}

function formatHeroTitle(title) {
  return escapeHtml(title).replace(/\*([^*]+)\*/g, "<span>$1</span>");
}

function highlightTitle(title) {
  const safe = escapeHtml(title);
  return safe
    .replace(/НОВАЯ МАРКА/g, "<span>НОВАЯ МАРКА</span>")
    .replace(/спектр услуг/g, "<span>спектр услуг</span>")
    .replace(/рекламы/g, "<span>рекламы</span>");
}

function resolveSlideImage(slide, index = 0) {
  if (slide?.image) return slide.image;
  const imageIndex = Number.isFinite(Number(slide?.imageIndex))
    ? Number(slide.imageIndex)
    : index;
  return DEFAULT_HERO_IMAGES[imageIndex] || DEFAULT_HERO_IMAGES[0] || "";
}

function resolveClientImage(item, index = 0) {
  if (item?.image) {
    const safe = window.NMSanitize?.safeHref?.(item.image, { allowData: true });
    if (safe) return safe;
    if (String(item.image).startsWith("/") || String(item.image).startsWith("data:image/")) {
      return item.image;
    }
  }
  const imageIndex = Number.isFinite(Number(item?.imageIndex))
    ? Number(item.imageIndex)
    : index;
  return DEFAULT_CLIENT_IMAGES[imageIndex] || DEFAULT_CLIENT_IMAGES[0] || "";
}

function resolveApproachIcon(item, index = 0) {
  if (item?.icon) {
    const safe = window.NMSanitize?.safeHref?.(item.icon, { allowData: true });
    if (safe) return safe;
    if (String(item.icon).startsWith("/") || String(item.icon).startsWith("data:image/")) {
      return item.icon;
    }
  }
  const iconIndex = Number.isFinite(Number(item?.iconIndex))
    ? Number(item.iconIndex)
    : index;
  return DEFAULT_APPROACH_ICONS[iconIndex] || DEFAULT_APPROACH_ICONS[0] || "";
}

function initClientsMarquee() {
  const root = document.documentElement;
  const list = document.querySelector(".clients-section .marquee__list");
  if (!list) return;

  const originals = [...list.querySelectorAll(".marquee__item[data-client-id]")];
  list.innerHTML = "";
  originals.forEach((node) => list.appendChild(node));

  root.style.setProperty("--marquee-elements", String(originals.length || 0));
  const displayedRaw = getComputedStyle(root).getPropertyValue("--marquee-elements-displayed");
  const displayed = Math.max(0, Math.floor(Number.parseFloat(displayedRaw) || 0));

  for (let i = 0; i < displayed; i += 1) {
    if (originals[i]) list.appendChild(originals[i].cloneNode(true));
  }
}

function renderClients(clients) {
  const section = document.querySelector(".clients-section");
  if (!section || !clients) return;

  const titleNode = section.querySelector("[data-home-clients-title]")
    || section.querySelector(".introduction__title");
  if (titleNode) {
    titleNode.innerHTML = formatHeroTitle(clients.title || DEFAULT_CLIENTS_TITLE);
  }

  const list = section.querySelector("[data-home-clients-list]")
    || section.querySelector(".marquee__list");
  if (!list) return;

  const items = Array.isArray(clients.items) ? clients.items : [];
  if (!items.length) {
    list.innerHTML = "";
    initClientsMarquee();
    return;
  }

  list.innerHTML = items.map((item, index) => {
    const src = resolveClientImage(item, index);
    return `
      <li class="marquee__item" data-client-id="${escapeHtml(item.id)}">
        <div class="clients-section__item">
          <div class="clients-section__img">
            <img src="${escapeHtml(src)}" alt="${escapeHtml(item.alt || "Логотип")}" width="156" height="78">
          </div>
        </div>
      </li>
    `;
  }).join("");

  initClientsMarquee();
}

function renderHero(slides) {
  const wrapper = document.querySelector("[data-home-hero]");
  if (!wrapper || !Array.isArray(slides)) return;

  if (!slides.length) {
    wrapper.innerHTML = `
      <div class="hero-section__slide swiper-slide">
        <div class="hero-section__block">
          <div class="hero-section__content">
            <h2 class="hero-section__title h1">Добавьте слайды в разделе «Контент»</h2>
          </div>
        </div>
      </div>
    `;
    if (typeof window.initHeroSwiper === "function") {
      window.initHeroSwiper();
    }
    return;
  }

  wrapper.innerHTML = slides.map((slide, index) => `
    <div class="hero-section__slide swiper-slide">
      <div class="hero-section__block">
        <div class="hero-section__content">
          <h2 class="hero-section__title h1">${formatHeroTitle(slide.title)}</h2>
          <button class="hero-section__btn btn btn_l" data-popup="popup-feedback" type="button">
            <span>${escapeHtml(slide.buttonText)}</span>
            <svg width="72" height="32" viewBox="0 0 72 32">
              <use xlink:href="#icon-arrow-long"></use>
            </svg>
          </button>
        </div>
        <div class="hero-section__img-container">
          <div class="hero-section__img">
            <picture>
              <img src="${escapeHtml(resolveSlideImage(slide, index))}" alt="">
            </picture>
          </div>
        </div>
      </div>
    </div>
  `).join("");

  if (typeof window.initHeroSwiper === "function") {
    window.initHeroSwiper();
  }
}

function bindHeroCta() {
  const root = document.querySelector(".hero-section");
  if (!root || root.dataset.heroCtaBound === "1") return;
  root.dataset.heroCtaBound = "1";

  root.addEventListener("click", (event) => {
    const button = event.target.closest(".hero-section__btn");
    if (!button) return;
    event.preventDefault();
    if (typeof window.openPopup === "function") {
      window.openPopup(button.getAttribute("data-popup") || "popup-feedback");
    }
  });
}

function renderDescription(description) {
  const root = document.querySelector(".index-page .location-section");
  if (!root || !description) return;

  const title = root.querySelector(".location-section__title");
  const paragraphs = root.querySelectorAll(".location-section__desc");

  if (title) {
    title.innerHTML = highlightTitle(description.title);
  }

  if (paragraphs[0]) paragraphs[0].textContent = description.paragraph1;
  if (paragraphs[1]) paragraphs[1].textContent = description.paragraph2;
}

function renderAchievements(achievements) {
  const root = document.querySelector(".index-page .location-section");
  if (!root || !Array.isArray(achievements)) return;

  const nodes = root.querySelectorAll(".location-section__achievement");
  nodes.forEach((node, index) => {
    const item = achievements[index];
    if (!item) return;
    const value = node.querySelector(".location-section__achievement-value");
    const label = node.querySelector(".location-section__achievement-desc");
    if (value) value.textContent = item.value;
    if (label) label.textContent = item.label;
  });
}

function renderApproach(approach) {
  const section = document.querySelector(".advantage-section");
  if (!section || !approach) return;

  const titleNode = section.querySelector("[data-home-approach-title]");
  if (titleNode) {
    titleNode.innerHTML = formatHeroTitle(approach.title || DEFAULT_APPROACH_TITLE);
  }

  const wrapper = section.querySelector("[data-home-approach-slides]");
  if (!wrapper) return;

  const items = Array.isArray(approach.items) ? approach.items : [];
  wrapper.innerHTML = items.map((item, index) => `
    <div class="advantage-section__slide swiper-slide">
      <div class="advantage-preview">
        <div class="advantage-preview__icon">
          <img src="${escapeHtml(resolveApproachIcon(item, index))}" alt="" width="96" height="96">
        </div>
        <div class="advantage-preview__content user-content">
          <h5>${escapeHtml(item.title)}</h5>
          <p>${escapeHtml(item.text)}</p>
        </div>
      </div>
    </div>
  `).join("");

  if (typeof window.initAdvantageSwiper === "function") {
    window.initAdvantageSwiper();
  }
}

function renderServicesSection(servicesSection) {
  const titleNode = document.querySelector("[data-home-services-title]");
  if (!titleNode || !servicesSection) return;
  titleNode.innerHTML = formatHeroTitle(servicesSection.title || DEFAULT_SERVICES_SECTION_TITLE);
}

function hydrateHomePage() {
  if (!document.querySelector(".index-page")) return;

  const data = getHomeData();
  renderHero(data.slides);
  bindHeroCta();
  renderDescription(data.description);
  renderAchievements(data.achievements);
  renderClients(data.clients);
  renderApproach(data.approach);
  renderServicesSection(data.servicesSection);
}

window.NMHomeContent = {
  STORAGE_KEY,
  DEFAULT_HERO_IMAGES,
  DEFAULT_CLIENT_IMAGES,
  DEFAULT_APPROACH_ICONS,
  DEFAULT_APPROACH_TITLE,
  DEFAULT_SERVICES_SECTION_TITLE,
  createId,
  escapeHtml,
  formatHeroTitle,
  resolveSlideImage,
  resolveClientImage,
  resolveApproachIcon,
  getHomeData,
  saveHomeData,
  getDefaultData,
  getDefaultClients,
  getDefaultApproach,
  getDefaultServicesSection,
  normalizeSlide,
  normalizeClientItem,
  normalizeClients,
  normalizeApproachItem,
  normalizeApproach,
  normalizeServicesSection,
  normalizeData,
  initClientsMarquee,
  renderClients,
  renderApproach,
  renderServicesSection,
  hydrateHomePage,
};

window.NMApi?.ready?.then(hydrateHomePage);
